<template>
  <img
    class="image-section"
    :src="`${$baseUrl}images/${imageName || 'shinsekai'}.webp`"
    alt=""
  />
</template>

<script setup>
import { inject } from "vue";

defineProps({
  imageName: String,
});

const $baseUrl = inject("$baseUrl");
</script>

<style lang="scss" scoped>
.image-section {
  width: 100%;
  height: 80vh;
  object-fit: cover;
}
</style>
